import { Binary } from "@angular/compiler";

export interface IAuditTrail {
    Name: string,
    UserGPN: string;
    CreatedOn?: Date;
    FieldName: string;
    OldValue: string;
    NewValue: string;
    Action: string;
}

export enum Roles {
    Finance = 1,
    ProspectSubmitter = 2,
    DPC = 3,
    Admin = 4
}

export interface IStatus {
    Id: number,
    Name: string
}

export interface IGSTINType {
    Id: number,
    Name: string
}

export enum MdmStatus {
    PendingWithClientServer = 1,
    PendingWithDPCForReview = 2,
    Reviewed = 3,
}

export interface IExcelUpload {
    AttachmentName?: string;
    FileAttached?: Binary;
    UploadedBy?: string;
    UploadedOn?: Date;
    ProcessedOn?: Date;
    Status?: string;
}


export interface IBPRecord {
    MdmId: string;
    BPName?: string;
    BPClassification?: string;
    AddressLine1?: string;
    AddressLine2?: string;
    AddressLine3?: string;
    AddressLine4?: string;
    AddressLine5?: string;
    City?: string;
    PostalCode?: string;
    BPCountry?: string;
    BPEmail?: string;
    BPPhoneNo?: string;
    BPRegionName?: string;
    BPAreaName?: string;
    EntityType?: string;
    BPStageName?: string;
    Pace_ID?: string;
    PACEStatus?: string;
    ProspectSubmitter?: string;
    ProspectSubmitterGPN?: string;
    StateProvinceRef?: string;
    StateProvinceName?: string;
    VatId?: string;
    VatIdCountry?: string;
    Tax1Id?: string;
    Tax1Country?: string;
    Tax2Id?: string;
    Tax2Country?: string;
    Tax3Id?: string;
    Tax3Country?: string;

    PANAttachmentName?: string;
    PANAttachmentType?: string;

    LoaAttachmentName?: string;
    LoaAttachmentType?: string;

    GSTAttachmentName?: string;
    GSTAttachmentType?: string;

    DeclarationAttachmentName?: string;
    DeclarationAttachmentType?: string;

    GSTINTypeName?: string;
    GSTINTypeId?: number;

    LoaValidityFrom?: Date;
    LoaValidityTo?: Date;

    Tax4Id?: string;
    Tax4Country?: string;
    Tax5Id?: string;
    Tax5Country?: string;
    NationalId?: string;
    NationalIdCountry?: string;
    EccId?: string;
    KeywordName?: string;
    pageNumber?: number;
    PageSize?: number;
    MdmStatus?: number;
    EccStatus?: number;
    Comment?: string;
    GstTan?: string;
    IsGovernmentClient: boolean;
    IsGstinAstaxDeductor: boolean;
    ReasonNonAvailabilityGSTIN?: string;
    ReasonNonAvailabilityPAN?: string;
    ReasonNonAvailabilityTAN?: string;
}

export interface IBPAddress {
    MdmId: string;
    BPName?: string;
    EccId?: string;
    AddressLine1?: string;
    AddressLine2?: string;
    AddressLine3?: string;
    AddressLine4?: string;
    AddressLine5?: string;
    City?: string;
    PostalCode?: string;
    StateProvinceRef?: string;
    StateProvinceName?: string;
    EmailAddress?: string;
    PhoneNumber?: string;
    RegionName?: string;
    AreaName?: string;
    EntityType?: string;
    RequestorName?: string;
    VatId?: string;
    VatIdCountry?: string;
    Tax1Id?: string;
    Tax1Country?: string;
    Tax2Id?: string;
    Tax2Country?: string;
    Tax3Id?: string;
    Tax3Country?: string;

    PANAttachmentName?: string;
    PANAttachmentType?: string;

    GSTAttachmentName?: string;
    GSTAttachmentType?: string;

    DeclarationAttachmentName?: string;
    DeclarationAttachmentType?: string;

    LoaAttachmentName?: string;
    LoaAttachmentType?: string;

    LoaValidityFrom?: Date;
    LoaValidityTo?: Date;

    GSTINTypeName?: string;
    GSTINTypeId?: number;

    Tax4Id?: string;
    Tax4Country?: string;
    Tax5Id?: string;
    Tax5Country?: string;
    NationalId?: string;
    NationalIdCountry?: string;
    BPCountry?: string;
    BPClassification?: string;
    UpdatedOn?: Date;
    ProspectSubmitterGPN?: string;
    MdmStatus?: number;

    GstTan?: string;
    ReasonNonAvailabilityGSTIN?: string;
    ReasonNonAvailabilityPAN?: string;
    ReasonNonAvailabilityTAN?: string;
    EccStatus?: number;
    Comments?: string;
}



